import axios, { AxiosResponse, AxiosRequestConfig, AxiosError } from "axios";
import { getRequestConfig, onFulfilled, onRejected } from "./resolvers";
import { RequireOne } from "../@typings/typings";

export interface HttpClientConfig extends RequireOne<AxiosRequestConfig, "url"> {}

export class HttpClient<T> {
  post: () => Promise<T>;

  get: () => Promise<T>;

  patch: () => Promise<T>;

  delete: () => Promise<T>;

  loader: (
    options: AxiosRequestConfig,
    resolve: (response: AxiosResponse) => Promise<T>,
    reject: (error: AxiosError) => Promise<any>
  ) => Promise<T>;

  constructor(private config: HttpClientConfig) {
    this.loader = (
      requestOptions: AxiosRequestConfig,
      resolve: (response: AxiosResponse) => Promise<T>,
      reject: (error: AxiosError) => Promise<any>
    ) => {
      return axios.request(requestOptions).then(resolve).catch(reject);
    };

    this.post = () => {
      return this.loader(getRequestConfig({ method: "POST", ...config }), onFulfilled, onRejected);
    };

    this.get = () => {
      return this.loader(getRequestConfig({ method: "GET", ...config }), onFulfilled, onRejected);
    };

    this.patch = () => {
      return this.loader(getRequestConfig({ method: "PATCH", ...config }), onFulfilled, onRejected);
    };

    this.delete = () => {
      return this.loader(getRequestConfig({ method: "DELETE", ...config }), onFulfilled, onRejected);
    };
  }
}
